export default __webpack_public_path__ + "static/media/7269c579eba97c3cbff1864fb9941368.png";